<!-- 弹框 -->
<template>
  <div class="bulletBox" v-show="show">
    <div class="box-inner" :style="`width: ${width};padding-top: calc(${width} * 0.7);`">
      <div class="closeBtn" v-show="showCloseBtn" @click="show = false"></div>
      <div class="pos-inner">
        <div class="title" v-if="title">{{ title }}</div>
        <div class="content sBox">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 控制显隐
    visible: {
      type: Boolean,
      default: false
    },
    // 宽度
    width: {
      type: String,
      default: '8rem'
    },
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 是否显示关闭按钮
    showCloseBtn: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      show: this.visible
    }
  },
  watch: {
    visible (newVal) {
      this.show = newVal
    },
    show (newVal, oldVal) {
      if (newVal !== this.visible) {
        this.$emit('update:visible', newVal)
      }
    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="less">
.bulletBox {}
</style>
